
import React from 'react';
import ServiceCard from '@/components/ServiceCard';
import { Shield, Server, Cloud, Users, Briefcase, Network, Computer } from 'lucide-react';

const ServicesSection: React.FC = () => {
  const services = [
    {
      title: "Managed IT Services",
      description: "Comprehensive proactive support to keep your systems running smoothly.",
      features: [
        "24/7 Monitoring & Support",
        "Remote & Onsite Help Desk",
        "Patch Management",
        "IT Asset Management",
        "Vendor Management",
        "Device Lifecycle Planning"
      ],
      icon: Server,
      link: "/services/managed-it"
    },
    {
      title: "Cybersecurity",
      description: "Protect your business from evolving cyber threats and data breaches.",
      features: [
        "Endpoint Detection & Response (EDR)",
        "Threat Detection & Blocking",
        "Email Protection & Phishing Prevention",
        "Multi-Factor Authentication (MFA)",
        "Secure Remote Access & VPN Setup",
        "Compliance Assistance (HIPAA, SOC2)"
      ],
      icon: Shield,
      link: "/services/cybersecurity"
    },
    {
      title: "Network & Infrastructure",
      description: "Build a reliable and secure foundation for your business operations.",
      features: [
        "Firewall & Wi-Fi Configuration",
        "Structured Cabling & Network Design",
        "NAS File Server Setup",
        "Active Directory Management",
        "VLAN & Port Management",
        "Secure Guest Wi-Fi Portals"
      ],
      icon: Network,
      link: "/services/network-infrastructure"
    },
    {
      title: "Cloud Solutions",
      description: "Leverage the power of cloud technology for flexibility and scalability.",
      features: [
        "Cloud Email & Productivity Suite Management",
        "Email Migrations & License Optimization",
        "Cloud Backup Solutions",
        "Hosted VoIP Phone Systems",
        "Hybrid Cloud Server Environments",
        "Thin Client Implementation"
      ],
      icon: Cloud,
      link: "/services/cloud-solutions"
    },
    {
      title: "Project Consulting",
      description: "Strategic guidance to align technology with your business objectives.",
      features: [
        "New Office Setup / Relocation",
        "Business Tech Stack Planning",
        "Software Recommendations",
        "IT Budgeting & Forecasting",
        "Risk & Vulnerability Assessments",
        "Technology Roadmap Development"
      ],
      icon: Briefcase,
      link: "/services/project-consulting"
    },
    {
      title: "Specialty Services",
      description: "Unique solutions tailored to specific business requirements.",
      features: [
        "Splash Pages & Check-in Wi-Fi",
        "Custom Desktop Applications",
        "Employee Onboarding/Offboarding",
        "Technology Training & Workshops",
        "IT Documentation & Knowledge Base"
      ],
      icon: Users,
      link: "/services/specialty-services"
    },
    {
      title: "Residential IT Support",
      description: "Expert technology solutions for homeowners and families.",
      features: [
        "Computer Repair & Maintenance",
        "Home Network Setup & Wi-Fi Optimization",
        "Smart Home Integration",
        "Data Backup & Recovery",
        "Tech Training for Families"
      ],
      icon: Computer,
      link: "/services/residential"
    }
  ];

  return (
    <section id="services" className="section-padding bg-white">
      <div className="container-wide">
        <div className="text-center mb-12">
          <h2 className="heading-lg text-itmgmt-dark-blue mb-4">Our Core Services</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            From day-to-day IT support to strategic technology planning, we provide comprehensive 
            solutions to keep your business running smoothly and securely.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <ServiceCard
              key={index}
              title={service.title}
              description={service.description}
              features={service.features}
              icon={service.icon}
              link={service.link}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
